<template>
	<div class="usercp-box">
		<el-row>
			<el-col :span="5">
				<el-menu
					class="usercp-sidebar"
					:default-active="currentMenu"
					@select="handleSelect"
				>
					<el-menu-item index="account">
						<i class="el-icon-postcard"></i>
						<span slot="title">账户设置</span>
					</el-menu-item>
					<el-menu-item index="collect">
						<i class="el-icon-star-off"></i>
						<span slot="title">我的收藏</span>
					</el-menu-item>
					<el-menu-item index="comment">
						<i class="el-icon-chat-dot-square"></i>
						<span slot="title">我的评论</span>
					</el-menu-item>
					<el-menu-item index="like">
						<i class="el-icon-collection"></i>
						<span slot="title">我赞过的文章</span>
					</el-menu-item>
					<el-menu-item index="logout">
						<i class="el-icon-switch-button"></i>
						<span slot="title">退出</span>
					</el-menu-item>
				</el-menu>
			</el-col>
			<el-col :span="19">
				<component :is="currentMenu"></component>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import Account from "@/components/Usercp/Account";
import Collect from "@/components/Usercp/Collect";
import Comment from "@/components/Usercp/Comment";
import Like from "@/components/Usercp/Like";

export default {
	name: "Usercp",
	components: { Account, Collect, Comment, Like },
	props: ["current"],
	data() {
		return {
			currentMenu: "account"
		};
	},
	methods: {
		handleSelect(key, keyPath) {
			if (key == "logout") {
				this.util.$emit("logout");
				window.location.href = "/";
				return;
			}
			// window.location.href = "/user/" + key;
			this.currentMenu = key;
		}
	},
	created() {
		// let path = window.location.pathname.split("/");
		// let currentMenu = path.pop();
		// this.currentMenu = currentMenu;
		if (this.current) {
			this.currentMenu = this.current;
		}
		// console.log(this.current);
	}
};
</script>

<style lang="less">
.usercp-box {
	margin: 30px 0;
	border: solid 1px #ddd;
	.usercp-primary {
		padding: 40px 60px;
		min-height: 650px;
		border-left: solid 1px #ddd;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/Usercp.vue